import '../client/polyfills'

import { render } from './render'
import { Routes } from './routes'

render({ Routes })

module.hot &&
  module.hot.accept('./routes', async () => {
    const { Routes } = await import('./routes')
    render({ Routes })
  })
